export default __webpack_public_path__ + "static/media/cooling-tower-round.2f06705f.png";